import SecureLS from 'secure-ls'
let ls = new SecureLS({ encodingType: 'aes', encryptionSecret: '3d0os3cr3t$@1' })
export default ls
